export default __webpack_public_path__ + "static/tecnologia-wallbox-mobile-5712e8ea006c205f678006412317f757.jpg";